import { render } from "./DemandTemplateTableRow.vue?vue&type=template&id=4585b1fc"
import script from "./DemandTemplateTableRow.vue?vue&type=script&lang=ts"
export * from "./DemandTemplateTableRow.vue?vue&type=script&lang=ts"
script.render = render

export default script